import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from '../views/Home.vue'
import HomeRead from '../views/HomeRead.vue'
import Phone from '../views/Phone.vue'
import PhoneDisplay from '../views/PhoneDisplay.vue'

const routes = [
  {
    path: '/pc',
    name: 'HomeRead',
    component: HomeRead
  },
  {
    path: '/pc-edit',
    name: 'Home',
    component: Home
  },
  {
    path: '/phone-edit',
    name: 'Phone',
    component: Phone
  },
  {
    path: '/',
    name: 'PhoneDisplay',
    component: PhoneDisplay
  }
]

const router = new VueRouter({
  mode: 'history', // 打包部署如果服务器没有配置伪静态，需要注释掉history模式使用默认的hash模式
  base: process.env.BASE_URL,
  routes
})

export default router